import { render, staticRenderFns } from "./AnalyticsAverageBounceRate.vue?vue&type=template&id=5f18dda5"
import script from "./AnalyticsAverageBounceRate.vue?vue&type=script&lang=js"
export * from "./AnalyticsAverageBounceRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports